import { render } from "./NewContentToLessonsCard.vue?vue&type=template&id=fe7e82e8&scoped=true"
import script from "./NewContentToLessonsCard.vue?vue&type=script&lang=js"
export * from "./NewContentToLessonsCard.vue?vue&type=script&lang=js"

import "./NewContentToLessonsCard.vue?vue&type=style&index=0&id=fe7e82e8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe7e82e8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
